// ==================== TRAINING MANAGEMENT APIs ====================

const bp = "/bp";

// ==================== Training Course Management ====================

// Create training course
export const create_training_course = async (data, success) => {
  try {
    const response = await fetch(`${bp}/create_training_course`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('Token')}`,
      },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (result.status === 'success') {
      success(result);
    } else {
      console.error('Error creating training course:', result.message);
    }
    return result;
  } catch (error) {
    console.error('Error in create_training_course:', error);
    throw error;
  }
};

// Get all training courses with optional filters
export const get_training_courses = async (params, success) => {
  try {
    const queryParams = params ? new URLSearchParams(params).toString() : '';
    const response = await fetch(
      `${bp}/get_training_courses${queryParams ? '?' + queryParams : ''}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('Token')}`,
        },
      }
    );
    const result = await response.json();
    if (result.status === 'success') {
      success(result);
    } else {
      console.error('Error fetching training courses:', result.message);
    }
    return result;
  } catch (error) {
    console.error('Error in get_training_courses:', error);
    throw error;
  }
};

// Update training course
export const update_training_course = async (data, success) => {
  try {
    const response = await fetch(`${bp}/update_training_course`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('Token')}`,
      },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (result.status === 'success') {
      success(result);
    } else {
      console.error('Error updating training course:', result.message);
    }
    return result;
  } catch (error) {
    console.error('Error in update_training_course:', error);
    throw error;
  }
};

// Delete training course
export const delete_training_course = async (course_id, success) => {
  try {
    const response = await fetch(`${bp}/delete_training_course`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('Token')}`,
      },
      body: JSON.stringify({ course_id }),
    });
    const result = await response.json();
    if (result.status === 'success') {
      success(result);
    } else {
      console.error('Error deleting training course:', result.message);
    }
    return result;
  } catch (error) {
    console.error('Error in delete_training_course:', error);
    throw error;
  }
};

// ==================== Employee Training Records ====================

// Create employee training record
export const create_training_record = async (data, success) => {
  try {
    const response = await fetch(`${bp}/create_training_record`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('Token')}`,
      },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (result.status === 'success') {
      success(result);
    } else {
      console.error('Error creating training record:', result.message);
    }
    return result;
  } catch (error) {
    console.error('Error in create_training_record:', error);
    throw error;
  }
};

// Get training records with filters
export const get_training_records = async (params, success) => {
  try {
    const queryParams = params ? new URLSearchParams(params).toString() : '';
    const response = await fetch(
      `${bp}/get_training_records${queryParams ? '?' + queryParams : ''}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('Token')}`,
        },
      }
    );
    const result = await response.json();
    if (result.status === 'success') {
      success(result);
    } else {
      console.error('Error fetching training records:', result.message);
    }
    return result;
  } catch (error) {
    console.error('Error in get_training_records:', error);
    throw error;
  }
};

// Get all training records for a specific employee with statistics
export const get_employee_trainings = async (employee_id, success) => {
  try {
    const response = await fetch(`${bp}/get_employee_trainings/${employee_id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('Token')}`,
      },
    });
    const result = await response.json();
    if (result.status === 'success') {
      success(result);
    } else {
      console.error('Error fetching employee trainings:', result.message);
    }
    return result;
  } catch (error) {
    console.error('Error in get_employee_trainings:', error);
    throw error;
  }
};

// Update training record
export const update_training_record = async (data, success) => {
  try {
    const response = await fetch(`${bp}/update_training_record`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('Token')}`,
      },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (result.status === 'success') {
      success(result);
    } else {
      console.error('Error updating training record:', result.message);
    }
    return result;
  } catch (error) {
    console.error('Error in update_training_record:', error);
    throw error;
  }
};

// Certify employee training (by admin/manager)
export const certify_employee_training = async (data, success) => {
  try {
    const response = await fetch(`${bp}/certify_employee_training`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('Token')}`,
      },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (result.status === 'success') {
      success(result);
    } else {
      console.error('Error certifying employee training:', result.message);
    }
    success(result);
  } catch (error) {
    console.error('Error in certify_employee_training:', error);
    throw error;
  }
};

// Verify training completion
export const verify_training_completion = async (data, success) => {
  try {
    const response = await fetch(`${bp}/verify_training_completion`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('Token')}`,
      },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (result.status === 'success') {
      success(result);
    } else {
      console.error('Error verifying training:', result.message);
    }
    return result;
  } catch (error) {
    console.error('Error in verify_training_completion:', error);
    throw error;
  }
};

// Get trainings expiring soon
export const get_expiring_trainings = async (params, success) => {
  try {
    const queryParams = params ? new URLSearchParams(params).toString() : '';
    const response = await fetch(
      `${bp}/get_expiring_trainings${queryParams ? '?' + queryParams : ''}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('Token')}`,
        },
      }
    );
    const result = await response.json();
    if (result.status === 'success') {
      success(result);
    } else {
      console.error('Error fetching expiring trainings:', result.message);
    }
    return result;
  } catch (error) {
    console.error('Error in get_expiring_trainings:', error);
    throw error;
  }
};

// ==================== Operation Training Requirements ====================

// Create operation training requirement
export const create_operation_requirement = async (data, success) => {
  try {
    const response = await fetch(`${bp}/create_operation_requirement`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('Token')}`,
      },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    // Call success callback with result (component will handle success/error)
    if (success) {
      success(result);
    }
    if (result.status !== 'success') {
      console.error('Error creating operation requirement:', result.message);
    }
    return result;
  } catch (error) {
    console.error('Error in create_operation_requirement:', error);
    throw error;
  }
};

// Get operation training requirements
export const get_operation_requirements = async (params, success) => {
  try {
    const queryParams = params ? new URLSearchParams(params).toString() : '';
    const response = await fetch(
      `${bp}/get_operation_requirements${queryParams ? '?' + queryParams : ''}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('Token')}`,
        },
      }
    );
    const result = await response.json();
    if (result.status === 'success') {
      success(result);
    } else {
      console.error('Error fetching operation requirements:', result.message);
    }
    return result;
  } catch (error) {
    console.error('Error in get_operation_requirements:', error);
    throw error;
  }
};

// Check if employee is qualified for an operation (CRITICAL for operation assignment)
export const check_employee_qualification = async (employee_id, operation_code, success) => {
  try {
    const response = await fetch(
      `${bp}/check_employee_qualification/${employee_id}/${operation_code}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('Token')}`,
        },
      }
    );
    const result = await response.json();
    if (result.status === 'success') {
      success(result);
    } else {
      console.error('Error checking qualification:', result.message);
    }
    return result;
  } catch (error) {
    console.error('Error in check_employee_qualification:', error);
    throw error;
  }
};

// ==================== Training Scheduling ====================

// Create training schedule
export const create_training_schedule = async (data, success) => {
  try {
    const response = await fetch(`${bp}/create_training_schedule`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('Token')}`,
      },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (result.status === 'success') {
      success(result);
    } else {
      console.error('Error creating training schedule:', result.message);
    }
    return result;
  } catch (error) {
    console.error('Error in create_training_schedule:', error);
    throw error;
  }
};

// Get training schedules
export const get_training_schedules = async (params, success) => {
  try {
    const queryParams = params ? new URLSearchParams(params).toString() : '';
    const response = await fetch(
      `${bp}/get_training_schedules${queryParams ? '?' + queryParams : ''}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('Token')}`,
        },
      }
    );
    const result = await response.json();
    if (result.status === 'success') {
      success(result);
    } else {
      console.error('Error fetching training schedules:', result.message);
    }
    return result;
  } catch (error) {
    console.error('Error in get_training_schedules:', error);
    throw error;
  }
};

// Enroll employee in training
export const enroll_employee_in_training = async (data, success) => {
  try {
    const response = await fetch(`${bp}/enroll_employee_in_training`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('Token')}`,
      },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (result.status === 'success') {
      success(result);
    } else {
      console.error('Error enrolling employee:', result.message);
    }
    return result;
  } catch (error) {
    console.error('Error in enroll_employee_in_training:', error);
    throw error;
  }
};
